module.exports = __webpack_public_path__ + "img/retail14.dd6f8570.png";